module.exports = __webpack_public_path__ + "img/CM-AE-25-Honda-Playful.26e0ed3e.jpg";